import { Currency } from '@/core/currency/interfaces';

const HTG: Currency = {
    name: 'Haitian Gourde',
    demonym: 'Haitian',
    majorSingle: 'Gourde',
    majorPlural: 'Gourdes',
    codeNumeric: '332',
    symbol: 'G',
    symbolNative: 'G',
    minorSingle: 'Centime',
    minorPlural: 'Centimes',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'HTG',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default HTG;
